import { addHours } from "date-fns";

export const dateDifference = addHours(0, 3);
